import React from 'react';
import ReactDOM from 'react-dom';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import defaultFlagsLD from './defaultFlagsLD.json';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'fonts';
import 'i18n';
import './styles.css';
import './handleErrors';
import { getLaunchDarklyKey } from 'utils/launchDarkly';

const renderApp = async () => {
  const ldKey = await getLaunchDarklyKey();
  const LDProvider = await asyncWithLDProvider({
    clientSideID: ldKey || '',
    reactOptions: { useCamelCaseFlagKeys: false },
    options: {
      bootstrap: ldKey ? undefined : defaultFlagsLD,
    },
  });

  ReactDOM.render(
    <LDProvider>
      <App />
    </LDProvider>,
    document.getElementById('root')
  );
  reportWebVitals();
};
renderApp();
